import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	categoryContainer: {
		background : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryBackgroundGrey,
		padding    : props?.deviceViewTab ? "5rem 20px 10rem" : "5rem 200px 10rem"
	},
	categoryHeaderConatiner: {
		display      : "flex",
		marginBottom : "5rem",
		gap          : "2.4rem",
		alignItems   : "center"
	},
	categoryHeading: {
		fontSize   : "2.5rem",
		fontWeight : "500",
		fontFamily : "Poppins",
		color      : theme.other.colors.text.primary
	},
	addTagButton: {
		border       : "none",
		padding      : "0.5rem 1rem",
		background   : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.secondaryLightGrey,
		borderRadius : "15px",
		color        : theme.other.colors.text.primary,
		alignItems   : "center",
		cursor       : "pointer"

	},
	selectedTag: {
		border       : "none",
		padding      : "0.5rem 1rem",
		background   : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.secondaryLightGrey,
		borderRadius : "15px",
		color        : theme.other.colors.text.primary,
		display      : "flex",
		alignItems   : "center"
	},
	tagCrossIcon: {
		width      : "19px",
		marginLeft : "5px",
		cursor     : "pointer"
	},
	selectedTagsWrapper: {
		display  : "flex",
		flexWrap : "wrap",
		gap      : "2rem"
	},
	postsList: {
		display             : "grid",
		gridTemplateColumns : props?.deviceMobileView ? "1fr" : props?.deviceViewTab ? "1fr 1fr" : " 1fr 1fr 1fr",
		gridGap             : "20px"
	}
} ) );
